/* ==========================================================
   Zewye90 — marquee.js
   Drives the scrolling wall by moving the container's scrollLeft
   instead of animating a CSS transform.

   Why: transforming the ~7000px track promotes it to a single GPU
   layer. That is larger than iOS Safari will hold, so the layer is
   dropped and re-rasterised mid-animation — the strip fades, vanishes,
   then reappears showing different products. A scroll container only
   ever rasterises the visible slice, so the oversized layer never
   exists. Cost is one property write per row per frame.
   ========================================================== */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var walls = document.querySelectorAll('[data-marquee]');
  if (!walls.length) return;

  walls.forEach(function (wall) {
    var seconds = parseFloat(wall.dataset.seconds) || 70;
    var rows = [];

    wall.querySelectorAll('[data-mq-row]').forEach(function (row) {
      var track = row.querySelector('[data-mq-track]');
      if (!track) return;
      rows.push({
        row: row,
        track: track,
        dir: parseFloat(row.dataset.dir) || 1,
        half: 0,
        pos: 0,
        seeded: false
      });
    });
    if (!rows.length) return;

    /* half the track is one complete set of prints; the duplicate set
       exists only so the wrap point is invisible */
    function measure() {
      rows.forEach(function (r) {
        var gap = parseFloat(getComputedStyle(r.track).columnGap) || 0;
        var half = (r.track.scrollWidth + gap) / 2;
        if (!half || !isFinite(half)) return;
        r.half = half;
        if (!r.seeded) {
          /* a reverse row starts one set in so it has room to travel back */
          r.pos = r.dir < 0 ? half : 0;
          r.seeded = true;
        }
        r.row.scrollLeft = r.pos;
      });
    }

    var visible = true;
    var hovered = false;
    var last = 0;

    function frame(now) {
      if (!last) last = now;
      /* clamp dt so returning to a backgrounded tab doesn't jump the strip */
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      if (visible && !hovered && !document.hidden) {
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (!r.half) continue;
          r.pos += (r.half / seconds) * dt * r.dir;
          if (r.pos >= r.half) r.pos -= r.half;
          if (r.pos < 0) r.pos += r.half;
          r.row.scrollLeft = r.pos;
        }
      } else {
        last = 0;
      }
      requestAnimationFrame(frame);
    }

    measure();
    window.addEventListener('load', measure);

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(measure, 200);
    }, { passive: true });

    wall.addEventListener('mouseenter', function () { hovered = true; });
    wall.addEventListener('mouseleave', function () { hovered = false; last = 0; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) last = 0;
        });
      }, { rootMargin: '200px 0px' }).observe(wall);
    }

    document.addEventListener('visibilitychange', function () { last = 0; });

    requestAnimationFrame(frame);
  });
})();
